import { MatDialog } from "@angular/material/dialog";
import { AdminsApi, Metadata } from "src/app/hickory-api";
import { SelectUsersComponent, SelectUsersData } from "src/app/shared/select-users/select-users.component";
import { AuthService } from "../../../authentication/auth.service";
import { AdminAuthZCollection, AuthorizationViewModel } from "../shared-authz-models";
import { AuthzConstants } from "../helpers/authz.constants";
import { AuthZAccessControl, AuthZDomain } from "src/app/shared/authentication/access-control";

export class OwnerAuthZCollection extends AdminAuthZCollection {

  override get can() { return true; }
  override canDeleteItems = false;

  public get addButton() {
    return {
      show: AuthZAccessControl.canChangeOwner(this.auth, this.domain),
      icon: 'contact_emergency',
      localizationKey: 'Change Owner'
    };
  }

  constructor(
    private readonly domain: AuthZDomain,
    private readonly auth: AuthService,
    service: AdminsApi,
    metadata: Metadata,
    dialog: MatDialog,
    actions: string[]
  ) {
    super(
      parseInt(metadata.tenantId) || auth.user.snapshot.tenantId,
      actions, metadata, 'Owner', 'contact_emergency',
      service, dialog, SelectUsersComponent
    )
  }

  public override loadData() {
    if (this.hasValues) {
      const currentUser = this.auth.user.snapshot;
      const owner = this._items[0];
      if (owner.id === currentUser.id) {
        const name = `${currentUser.name.givenName},  ${currentUser.name.familyName}`;
        this._items[0].name = name;
        return;
      }
      super.loadData();
    }
  }

  protected override processDialogResult(r: SelectUsersData, metadata: Metadata): Metadata {
    if(r && this.addButton.show) {
      const selected = this.mapper(r).filter(x => x.id > 0);
      console.log('OwnerAuthZCollection.processDialogResult', selected);
      this._items = selected.map(x => {
        x.actions = this.actions;
        return x
      });
      return {
        ...metadata,
        ownerId: this._items[0].id.toString()
      };
    }
  }

  protected override buildDialogData(): SelectUsersData {
    return this.buildSelectUsersData('Select an Owner', 'Change Owner', true);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  override isActionReadonly(item: AuthorizationViewModel, action: string): boolean {
    return true;
  }

  override setItemsFromMetadata(metadata: Metadata): void {
    const owner = this.getOwner(metadata);
    if (owner) {
      for (const action of this.actions) {
        owner.grantAction(action);
      }
      owner.readonly = true;
      owner.tags = [AuthzConstants.OWNER_TAG];
      this.setItems([owner]);
    }
  }

  private getOwner(metadata: Metadata): AuthorizationViewModel {
    if (metadata.ownerId) {
      const ownerId = parseInt(metadata.ownerId);
      let owner = this.find(x => x.id === ownerId);
      if (!owner) {
        owner = new AuthorizationViewModel();
        owner.actions = this.actions;
        owner.id = ownerId;
      }
      return owner;
    }
    return null;
  }
}